module.exports = __webpack_public_path__ + "static/media/recs-alt-bg.6d0a3aca.png";